import { createFileRoute, Navigate } from '@tanstack/react-router'

export const Route = createFileRoute('/(redirects)/bak/contracts/$subscriptionId/new-invoice')({
  component: () => (
    <Navigate
      replace
      search
      from="/bak/contracts/$subscriptionId/new-invoice"
      to="/bo/contracts/$subscriptionId/invoices/new"
    />
  ),
})
